<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-heading">
            <h1 class="modal-title">{{ adminText('workflowsAll.order_successfully_processed_3956051', 'Order Successfully Processed') }}</h1>
            <p class="modal-description">
              {{ adminText('workflowsAll.your_order_has_been_successfully_processed_yo_86bf82b', 'Your order has been successfully processed. You can now print your tickets or review your order details.') }}
            </p>
          </div>
          <button
            class="close-button"
            type="button"
            :aria-label="adminText('workflowsAll.close_bbfa773', 'Close')"
            @click="$emit('closeModal')"
          >
            <v-icon color="#666666">close</v-icon>
          </button>
        </div>
        <div v-if="tisakFeeBuckets.length" class="purchase-summary">
          <div
            v-for="bucket in tisakFeeBuckets"
            :key="bucket.feeWithVat"
            class="purchase-summary-row"
          >
            <span>{{ workflowLabel(bucket.count) }} {{ adminText('workflowsAll.x_tisak_naknada_3c87c0e', 'x Tisak naknada') }} {{ workflowLabel(bucket.feeWithVat.toFixed(2)) }} EUR</span>
            <strong>{{ workflowLabel(bucket.total.toFixed(2)) }} EUR</strong>
          </div>
        </div>
      </div>

      <div class="modal-actions">
        <button class="secondary-button" type="button" @click="$emit('viewOrder')">
          {{ adminText('workflowsAll.view_order_0df2797', 'View order') }}
        </button>
        <button class="primary-button" type="button" @click="$emit('printTickets')">
          <v-icon color="white" size="24">print</v-icon>
          {{ adminText('workflowsAll.print_tickets_5f4b92f', 'Print tickets') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'successful-payment-modal',
  props: {
    purchaseSummary: {
      type: Object,
      default: null,
    },
  },
  computed: {
    tisakFeeBuckets() {
      return (this.purchaseSummary && this.purchaseSummary.tisakFeeBuckets) || []
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}

.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 50.125rem;
  border-radius: 12px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  box-shadow: 0 0 24px rgba(51, 51, 51, 0.2);
}

.modal::-webkit-scrollbar {
  display: none;
}

.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  letter-spacing: 0;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
  margin: 0;
}

.modal-content {
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
}

.modal-heading {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.close-button {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-radius: 48px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 4px;
  width: 32px;
}

@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.modal-description {
  margin: 0;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
}

.purchase-summary {
  border-top: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
}

.purchase-summary-row {
  align-items: center;
  color: #333333;
  display: flex;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  justify-content: space-between;
  line-height: 1.5;
}

.modal-actions {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 32px 24px 24px;
}

.primary-button,
.secondary-button {
  align-items: center;
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  font-family: 'Raleway';
  font-size: 18px;
  font-weight: 700;
  gap: 8px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.2;
  padding: 12px 24px;
  text-align: center;
  text-transform: uppercase;
}

.primary-button {
  background: #0277bd;
  border: 2px solid #0277bd;
  color: #ffffff;
}

.secondary-button {
  background: #ffffff;
  border: 2px solid #0277bd;
  color: #0277bd;
}

@media screen and (max-width: 700px) {
  .modal-content {
    padding-right: 56px;
  }

  .close-button {
    position: absolute;
    right: 16px;
    top: 16px;
  }

  .modal-actions {
    align-items: stretch;
    flex-direction: column;
    gap: 16px;
  }

  .primary-button,
  .secondary-button {
    width: 100%;
  }
}
</style>
